module.exports = __webpack_public_path__ + "static/media/IMG_20201128_155426_398.47c63e16.jpg";